import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Trash2, Download, Mail } from "lucide-react";

export default function AdminNewsletter() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get("/admin/newsletter"); setItems(data); }
    catch (e) { toast.error(formatApiError(e)); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const remove = async (s) => {
    if (!window.confirm(`Remove ${s.email}?`)) return;
    try { await api.delete(`/admin/newsletter/${s.id}`); toast.success("Removed"); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  const exportCsv = () => {
    const csv = "email,subscribed_at\n" + items.map((s) => `${s.email},${s.subscribed_at}`).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `newsletter-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
  };

  return (
    <div data-testid="admin-newsletter-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-2xl lg:text-3xl font-heading font-semibold text-slate-900">Newsletter Subscribers</h1>
          <p className="text-slate-500 mt-1">People who subscribed to health tips via the footer form.</p>
        </div>
        <button onClick={exportCsv} className="btn-outline" data-testid="newsletter-export"><Download className="w-4 h-4" /> Export CSV</button>
      </div>

      <div className="mt-8 card-medi overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider">
              <tr>
                <th className="text-left px-6 py-3 font-medium">Email</th>
                <th className="text-left px-6 py-3 font-medium">Subscribed</th>
                <th className="text-right px-6 py-3 font-medium">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {loading && <tr><td colSpan={3} className="px-6 py-6 text-slate-500">Loading…</td></tr>}
              {!loading && items.length === 0 && <tr><td colSpan={3} className="px-6 py-8 text-center text-slate-500">No subscribers yet.</td></tr>}
              {items.map((s) => (
                <tr key={s.id} data-testid={`newsletter-row-${s.id}`}>
                  <td className="px-6 py-4 font-medium text-slate-800 flex items-center gap-2"><Mail className="w-4 h-4 text-red-600" /> {s.email}</td>
                  <td className="px-6 py-4 text-slate-500">{new Date(s.subscribed_at).toLocaleString()}</td>
                  <td className="px-6 py-4 text-right">
                    <button onClick={() => remove(s)} className="p-2 rounded-lg hover:bg-red-50 text-red-600" data-testid={`newsletter-delete-${s.id}`}><Trash2 className="w-4 h-4" /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
